import type { ProcessingOptionsInterface } from '../interfaces'
import type { resizeOptionsType } from '../types'

import { parseArguments } from '../helper/helper'
import { RESIZING_TYPE } from '../types'

export class ResizeProcessingOption implements ProcessingOptionsInterface {
  width?: number

  height?: number

  enlarge?: boolean

  extend?: boolean

  rsType?: RESIZING_TYPE

  readonly orderOptions = ['rsType', 'width', 'height', 'enlarge', 'extend']

  readonly defaultValue = {
    rsType: RESIZING_TYPE.FIT,
    width: undefined,
    height: undefined,
    enlarge: false,
    extend: false,
  }

  constructor({ rsType, width, height, enlarge, extend }: resizeOptionsType) {
    this.width = width
    this.height = height
    this.enlarge = enlarge
    this.extend = extend
    this.rsType = rsType
  }

  update({ rsType, width, height, enlarge, extend }: resizeOptionsType) {
    this.width = width
    this.height = height
    this.enlarge = enlarge
    this.extend = extend
    this.rsType = rsType
    return this
  }

  parseOptions(): string {
    const argsOrder: unknown[] = this.orderOptions.map((key: string): unknown => this[key])
    const defaultValue: unknown[] = this.orderOptions.map(
      (key: string): unknown => this.defaultValue[key],
    )

    const args = parseArguments(argsOrder, defaultValue)

    return `rs:${args}`
  }
}
